import { Object3D, Vector3 } from 'three'

import * as Util from './util'
import { vectorToQR } from './coords'

export default class Building extends Object3D {
  constructor(name, asset, factory) {
    super()
    this._blocked = false
    this._disabled = false
    this._animations = []
    this._productionMultiplier = 1
    this._displayingType = false
    this._productionAmounts = []
    this._pricePerLevel = []
    this._asset = asset
    this._type = ''
    this._maxLevel = 0
    this._level = 0
    this._built = false
    this._evolving = false
    this._destroying = false
    this.repared = false
    this._name = name
    this._factory = factory
    this._onLoadModel = (model) => model
    this.rotation.set(1.57, 0, 0)
    this._animationRunning = false
  }
  getAsset() {
    return this._asset
  }
  getEvolving() {
    return this._evolving
  }
  get getBlocked() {
    return this._blocked
  }
  get getDisabled() {
    return this._disabled
  }
  getBuilt() {
    return this._built
  }
  getDestroying() {
    return this._destroying
  }

  get getAnimations() {
    return this._animations
  }
  setBlocked(blocked) {
    this._blocked = blocked
  }
  setLevel(level) {
    this._level = level
  }
  setCurrentAnimation(animation) {
    this._animationRunning = animation
  }
  setMaxLevel(mL) {
    this._maxLevel = mL
  }
  setPosition(vector) {
    if (vector instanceof Vector3) {
      this.position.set(vector.x, vector.y, 0.05)
      this._qr = vectorToQR(vector)
      this.name = this._qr.q + '_' + this._qr.r
    }
  }
  setProductionAmount(pA) {
    this._productionAmounts = pA
  }
  setPricePerLevel(ppL) {
    this._pricePerLevel = ppL
  }
  setName(name) {
    this._name = name
  }
  setType(type) {
    this._type = type
  }
  setDisabled(disable) {
    this._disabled = disable
  }
  set setDisplayType(display) {
    this._displayingType = display
  }
  set onLoadModel(callback) {
    this._onLoadModel = callback
  }

  setEvolving(value) {
    this._evolving = value
  }
  setBuilt(value) {
    this._built = value
  }
  setDestroying(value) {
    this._destroying = value
  }

  setProductionMultiplier(amount) {
    this._productionMultiplier = amount
  }

  getProductionAmount() {
    if (this._productionAmounts.length == 0) {
      return 0
    } else {
      return this._productionAmounts[this._level - 1] * this._productionMultiplier
    }
  }

  getCurrentPrice() {
    if (this._pricePerLevel.length == 0) {
      return 0
    } else {
      return this._pricePerLevel[this._level - 1]
    }
  }

  stopEvolving() {
    if (this._evolving) {
      this._evolving = false
    } else {
      console.log('Building not evolving atm.')
    }
  }
  incrementLevel(level) {
    if (this._level < this._maxLevel) this._level += level
  }
  getType() {
    return this._type
  }
  getName() {
    return this._name
  }
  getLevel() {
    return this._level
  }
  setAnimations(animations) {
    this._animations = animations
  }
  printData() {
    return Object.assign({ _name: this._name }, this.getQRPosition, {
      type: this._type,
      level: this._level,
      evolving: this._evolving,
      built: this._built,
      destroying: this._destroying,
      repared: this._repared,
      blocked: this._blocked,
      disabled: this._disabled,
      price: this.getCurrentPrice(),
      production: this.getProductionAmount(),
      multiplier: this._productionMultiplier,
    })
  }
  get getQRPosition() {
    return this._qr
  }

  load(url) {
    this._factory
      .loadModel(url ? url : this._asset)
      .then((model) => {
        let actualModel = null
        if (this._animationRunning) {
          actualModel = Util.deepClone(model)
        } else {
          actualModel = model
        }
        this.traverse((node) => {
          this.remove(node)
        })

        Util.applyShadowOnModel(actualModel)
        // Util.sortGeometryByIndex(actualModel)
        this.add(actualModel)
        this._onLoadModel(actualModel)
      })
      .catch((err) => {
        console.log(err)
      })
  }
}
